export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14594.3bd69157.jpg";